import styled, { createGlobalStyle } from 'styled-components';

const CALENDAR_WIDTH = 364;
const CALENDAR_HEIGHT = 296;

export const DisableBodyScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

export const DateInputContainer = styled.div<{}>`
  position: relative;
`;

export enum CalendarPosition {
  top = 'top',
  right = 'right',
  left = 'left',
}

export const DateInputSubstrate = styled.div<{ zIndex?: number }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex || 201};
`;

interface IDateInputStyledProps {
  anchor?: { x: number; y: number };
  position?: CalendarPosition;
  zIndex?: number;
}

export const DateInputStyled = styled.div<IDateInputStyledProps>`
  position: fixed;
  width: ${CALENDAR_WIDTH}px;
  z-index: ${({ zIndex }) => zIndex || 202};
  ${({ anchor, position }) => getPositionStyles(position, anchor)};
`;

const getPositionStyles = (position?: CalendarPosition, anchor?: { x: number; y: number }): string => {
  if (position === CalendarPosition.right) {
    return `top: ${(anchor && anchor.y) || 0}px;
      left: ${((anchor && anchor.x) || 0) - CALENDAR_WIDTH}px;`;
  } else if (position === CalendarPosition.left) {
    return `top: ${(anchor && anchor.y) || 0}px;
      left: ${(anchor && anchor.x) || 0}px;`;
  } else if (position === CalendarPosition.top) {
    return `top: ${((anchor && anchor.y) || 0) - CALENDAR_HEIGHT}px;
     left: ${(anchor && anchor.x) || 0}px;`;
  } else {
    return `top: 42px;`;
  }
};
